import(/* webpackMode: "eager" */ "/vercel/path0/app/template.tsx");
